<template>
    <div v-if="$store.state.connected" class="account">
        <h1>Informations personnelles</h1>
        <EditInformations id="editInformations" />
        <EditPassword id="editPassword" />
    </div>
</template>

<script>
    import EditInformations from "@/components/Edit/EditInformations.vue";
    import EditPassword from "@/components/Edit/EditPassword.vue";
    
    import router from "../router/index.js";
    
    export default {
        name: "Account",
        components: {
            EditInformations,
            EditPassword,
        },
        data(){
            return{
            }
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>

<style scoped>

    #editInformations {
        margin-bottom: 20px;
    }
    
</style>

<style>
    .editForm{
        width: 40%;
    }
    @media screen and (max-width: 800px){
        .editForm{
            width: 90%;
        }
    }
</style>